<template>
<div class="main_wrap unit">
    <div class="myMenu" style="position:unset;margin: 20px auto;">
        <div @click="goWorkPlat">执法管理</div>
        <!-- <div v-if="handle_pool" @click="poolList">警情池</div>
        <div @click="goReceive">接警记录</div>
        <div @click="reportList">举报管理</div> -->
        <div  class="priority" v-if="command=='超级管理员' || command=='高级管理员'">人员管理</div>
        <div @click="unitList" v-if="command=='超级管理员' || command=='高级管理员'">单位管理</div>
        <!-- <div v-if="command=='超级管理员'||command=='高级管理员'" @click="examineList">我的审批</div> -->
    </div>
    <div class="search-box ">
        <div class="select-wrap">
            <div class="group situation margin-right-15 searchArrow">
                <span class="left">所属单位</span>
                <div class="right">
                    <el-select placeholder="全部" class="" v-model="model.organizationId">
                        <el-option v-for="item in organizationList" :key="item.id" :label="item.simpName" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="group margin-right-15">
                <span class="left">姓名</span>
                <div class="right">
                    <input type="text" placeholder="请输入姓名" v-model.trim="model.realname">
                </div>
            </div>
            <div class="group margin-right-15">
                <span class="left">登录账号</span>
                <div class="right">
                    <input type="text" placeholder="请输入登录账号" v-model.trim="model.username">
                </div>
            </div>
            <div class="group margin-right-15">
                <span class="left">手机号</span>
                <div class="right">
                    <input type="text" placeholder="请输入手机号" v-model.trim="model.phone">
                </div>
            </div>
            <div class="group margin-right-15">
                <span class="left">警员号</span>
                <div class="right">
                    <input type="text" placeholder="请输入警员号" v-model.trim="model.policeNo">
                </div>
            </div>
        </div>
        <div class="select-wrap">
            <div class="group btn-box">
                <button type="submit" class="btn" @click="search">搜索</button>
                <button type="button" @click="newadd" class="btn">新增</button>
                <button type="button" @click="deletes" class="btn">删除</button>
            </div>
        </div>
    </div>
    <div class="table_wrap" v-show="!detailShow">
        <div class="table_layout">
            <div class="table_scroll">
                <el-table border :data="dataList" :cell-style="cellStyle" :header-cell-style="tableHeaderColor" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="60"></el-table-column>
                    <el-table-column min-width="80" align="center" label="姓名" key="1" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.realname}}</template>
                    </el-table-column>
                    <el-table-column min-width="100" align="center" label="登录账号" key="2" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.username}}</template>
                    </el-table-column>
                    <el-table-column min-width="130" align="center" label="身份证号" key="3" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.identityCardNo}}</template>
                    </el-table-column>
                    <el-table-column min-width="100" align="center" label="手机号" key="4" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.phone}}</template>
                    </el-table-column>
                    <el-table-column min-width="160" align="center" label="小程序用户编号" key="6" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.miniOpenId}}</template>
                    </el-table-column>
                    <el-table-column align="center" label="认证状态" key="7" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.miniOpenId == null ? "未实名认证" : "已实名认证"}}</template>
                    </el-table-column>
                    <el-table-column align="center" label="岗位角色" key="8" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.roleNames}}</template>
                    </el-table-column>
                    <el-table-column min-width="100" align="center" label="操作" key="9" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span class="primary pointer mr15" v-bind:val="val" @click="alter(scope.row)">修改</span>
                            <span class="primary pointer" @click="deletes(scope.row)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="!dataList.length">
                <nt-no-data></nt-no-data>
            </div>
            <div class="pagination" v-if="dataList.length">
                <nt-pagination ref="child" @fetchData="fetchData"></nt-pagination>
            </div>
        </div>
    </div>
    <transition name="el-zoom-in-center">
        <detail v-if="detailShow" :val="val" @func="getRoleSon" @fetchData="fetchData"></detail>
    </transition>
</div>
</template>

<script>
import config from "@/common/env"
import { mapState } from 'vuex'
import detail from './detail'

export default {
    name: "list",
    components: {
        detail
    },
    data() {
        return {
            model: {
                page: 1, //页码
                realname: null,
                size: 10, //单页数量
                username: null,
                organizationId: null,
                phone: null,
                policeNo: null,
                miniOpenId: null,
                needAuthConfirm: null,
            },
            val: {
                id: null,
            },
            dataList: [],
            organizationList: [],
            editShow: false, //新增-编辑弹层显示字段
            detailShow: false,
            tableDataAmount: null,
            delete: [],

            handle_pool: config.handle_pool,

        }
    },
    computed: {
        ...mapState(['userInfo','command']),

        crumbList() {
            return this.$route.meta.crumbList;
        },

    },
    watch: {
        command(newV) {
        console.log(newV)
            if(newV != "超级管理员" || newV != "高级管理员") {
                this.goWorkPlat()
            }
        },
        
    },
    mounted() {
        this.fetchData();
        this.getOrganizationList()
    },
    methods: {
        examineList() {
          this.$router.push('/examine');
        },
		goWorkPlat() {
            this.$router.push('/workPlat');
            // window.open('/workPlat', this.getWindowName('workPlat')).focus();
        },
        goReceive() {
            this.$router.push('/receive');
        },
        unitList() {
            this.$router.push('/unit');
        },
        cellStyle({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            return 'height:20px; font-size:12px';
        },
        tableHeaderColor({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            if (rowIndex === 0) {
                return 'background-color:#f4f5f7; height:40px; color:#4a4a4a!important; font-size:13px';
            }
        },
        getOrganizationList() {
            this.$axios.get('/admin/user/organizationList').then(res => { //所属单位
                let data = this.AppUtils.checkResponse(res);
                if (data) {
                    this.organizationList = data.data
                }
            })
        },
        fetchData(args) {
            // 初始化分页
            // this.model.page = 1;
            // this.model.size = 10;
            if (args) {
                if (args.page) { //分页
                    this.model.page = args.page; //当前页数
                    this.model.size = args.pageSize; //每页显示多少条
                }
            }
            this.$axios.post('/admin/user/list', this.model).then(res => { //列表
                let data = this.AppUtils.checkResponse(res);
                if (data) {
                    this.dataList = data.data.list;
                    if (this.dataList.length > 0) {
                        this.$nextTick(() => {
                            this.$refs.child.initPage(data.data.total, this.model.page, this.model.size);
                        })
                    }
                }
            })
        },
        search() {
            this.model.page = 1;
            this.model.size = 10;
            this.fetchData();
        },
        handleSelectionChange(data) {
            this.tableDataAmount = data
        },
        deletes(val) { //删除
            let dele = this.tableDataAmount
            let params = null
            let vals = val
            if (dele) {
                dele.forEach(item => {
                    this.delete.push(item.id)
                })
                params = {
                    ids: this.delete.toString()
                }
            } else {
                params = {
                    ids: vals.id
                }
            }
            // console.log(params,'params')
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.post('/admin/user/deleteUser', params).then(res => {
                    console.log(res)
                    this.fetchData()
                })
            }).catch(() => {

            })
        },
        alter(val) {
            this.detailShow = true
            this.val.id = val.id
            console.log(this.val.id)
        },
        getRoleSon() {
            this.detailShow = this.detail
        },
        newadd() {
            this.detailShow = true;
            this.val.id = null;
        },

    }
}
</script>

<style lang="scss" scoped>
.mr15 {
    margin-right: 15px;
}

.select-wrap {
    padding-left: 20px;

    .date-box {
        width: 346px;
    }

    &>.group {
        margin-right: 50px;

        span.left {
            width: auto;
        }

        .el_box {
            width: 110px;
        }

    }

    .area {
        margin-left: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// list.vue?9b53ceea